import { useCallback } from 'react';
import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { DeleteIssueRequest } from './types.tsx';

const getDeletionUrl = (issueKey: string) => `/rest/api/3/issue/${issueKey}?deleteSubtasks=true`;

export const useDeleteIssue = () =>
	useCallback(
		({ issueKey }: DeleteIssueRequest) =>
			performDeleteRequest(getDeletionUrl(issueKey), { method: 'DELETE' }),
		[],
	);
